// @flow

import * as React from 'react';
import { Flex, Box } from 'react-system';
import InputAdornment from '@material-ui/core/InputAdornment';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import IconButton from '@material-ui/core/IconButton';
import * as icons from '../../../icons';
import { useLocale } from '../../../hooks/locale.js';
import { createDescriptor } from '../../../controls/router';
import { useDebounce } from '../../../hooks/debounce';
import { pageDescriptor, agencyFilterDescriptor } from './sharedDescriptors';

type Props = {|
  inline?: boolean,
  shouldFlush: boolean,
|};

const combinedFilterDescriptor = createDescriptor(
  agencyFilterDescriptor,
  pageDescriptor,
);
export const AgencyFilter = (props: Props): React.Node => {
  const { t } = useLocale();
  const [
    configFilters,
    setConfigFilters,
    flushConfigFilters,
  ] = combinedFilterDescriptor.useState();
  const [referenceInput, setReferenceInput] = React.useState(
    configFilters.agencyReference_contains,
  );
  const flush = () => {
    setConfigFilters({ page: 0 });
    if (props.shouldFlush) {
      flushConfigFilters();
    }
  };
  const submit = useDebounce(value => {
    setConfigFilters({
      agencyReference_contains: value,
    });
    flush();
  }, 300);

  return (
    <Flex p={3} pb={3} flexWrap="wrap">
      <Box width={3}>
        <OutlinedInput
          variant="outlined"
          placeholder={t('enterReferenceId')}
          value={referenceInput == null ? '' : referenceInput}
          endAdornment={
            referenceInput != null && (
              <InputAdornment position="end">
                <IconButton
                  edge="end"
                  onClick={() => {
                    setReferenceInput(null);
                    submit(null);
                  }}
                >
                  <icons.Cancel />
                </IconButton>
              </InputAdornment>
            )
          }
          onChange={event => {
            setReferenceInput(event.target.value);
            submit(event.target.value);
          }}
        />
      </Box>
    </Flex>
  );
};
